import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { LoggerService } from '@app/shared/services/logger.service';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { SharedModule } from '@app/shared/shared.module';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';

@TakeUntilDestroy
@Component({
  selector: 'slotcom-multi-gamechallenges-start-modal',
  templateUrl: './multi-gamechallenges-start.component.html',
  styleUrls: ['./multi-gamechallenges-start.component.scss'],
  standalone: true,
  imports: [AnimatedTimerComponent, ButtonComponent, SharedModule],
})
export class MultiChallengesStartModalComponent implements OnInit {
  multiGameChallengesStartModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  logger = inject(LoggerService);
  private translateService = inject(TranslateService);
  private eventsRepo = inject(EventsRepository);

  componentDestroy: () => Observable<unknown>;

  event: LimitedTimeEvent;
  lang: string;

  ngOnInit(): void {
    this.lang = this.translateService.currentLang;
    this.event = this.eventsRepo.getEventById(this.multiGameChallengesStartModalData.properties.eventId);
  }

  closeModal(): void {
    this.eventManager.closeModal(
      new Modal(this.multiGameChallengesStartModalData.id, ModalType.Persisted, this.multiGameChallengesStartModalData)
    );
  }

  openMultiGameChallenges(): void {
    this.eventManager.openModal(
      new Modal(
        NonPersistedModalName.MultiChallengesModalComponent,
        ModalType.View,
        this.eventsRepo.getEventById(this.multiGameChallengesStartModalData.properties.eventId)
      )
    );
    this.closeModal();
  }
}
